import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import StaffRolesApi from '@/services/apiServiceModules/staffRolesApi.js'
const staffRolesApi = new StaffRolesApi()

export default class StaffRolesDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.STAFF_ROLES, staffRolesApi, {
			useCache: true,
		})
	}
}
